// Product Permission Constants
export const PRODUCT_TRANSACTIONS = "p_transactions";
export const PRODUCT_QUOTATIONS = "p_quotations";
export const PRODUCT_USER_MANAGEMENT = "p_user_management";
export const PRODUCT_COMPANY_SETUP = "p_company_setup";

// Screen Permission Constants
export const SCREEN_TRANSACTIONS = "s_transactions";
export const SCREEN_QUOTATIONS = "s_quotations";
export const SCREEN_USER_MANAGEMENT = "s_user_management";
export const SCREEN_COMPANY_SETUP = "s_company_setup";

// Function Permission Constants
export const FUNCTION_USER_MANAGEMENT_CREATE = "f_user_management_create";
export const FUNCTION_USER_MANAGEMENT_UPDATE = "f_user_management_update";
export const FUNCTION_USER_MANAGEMENT_DEACTIVATE =
	"f_user_management_deactivate";
export const FUNCTION_USER_MANAGEMENT_LISTING = "f_user_management_listing";
export const FUNCTION_TRANSACTIONS_LISTING = "f_transactions_listing";
export const FUNCTION_TRANSACTIONS_LISTING_MOTOR = "f_transactions_listing_motor";
export const FUNCTION_QUOTATIONS_TRANSFER_OWNERSHIP_LISTING =
	"f_quotations_transfer_ownership_listing";
export const FUNCTION_QUOTATIONS_TRANSFER_OWNERSHIP_LISTING_MOTOR =
	"f_quotations_transfer_ownership_listing_motor";
export const FUNCTION_QUOTATIONS_TRANSFER_OWNERSHIP_SUBMIT =
	"f_quotations_transfer_ownership_submit";
export const FUNCTION_QUOTATIONS_RENEWAL_LISTING =
	"f_quotations_renewal_listing";
	export const FUNCTION_QUOTATIONS_RENEWAL_LISTING_MOTOR =
	"f_quotations_renewal_listing_motor";
export const FUNCTION_QUOTATIONS_RENEWAL_SUBMIT = "f_quotations_renewal_submit";
export const FUNCTION_QUOTATIONS_NEW_REGISTER_LISTING =
	"f_quotations_new_register_listing";
export const FUNCTION_QUOTATIONS_NEW_REGISTER_SUBMIT =
	"f_quotations_new_register_submit";
export const FUNCTION_QUOTATIONS_BULK_CREATE = "f_quotations_bulk_create";
export const FUNCTION_COMPANY_SETUP_CREATE = "f_company_setup_create";
export const FUNCTION_COMPANY_SETUP_DEACTIVATE = "f_company_setup_deactivate";
export const FUNCTION_COMPANY_SETUP_LISTING = "f_company_setup_listing";
export const FUNCTION_COMPANY_SETUP_UPDATE = "f_company_setup_update";

// User Role Constants
export const USER_ROLE_RENEWAL = "Renewal";
export const USER_ROLE_TRANSACTIONS = "Transactions";
export const USER_ROLE_ADMIN = "Dealer_Admin";
